export default function CompanyHistory() {
  const historyData = [
    {
      year: '1990년대 초',
      title: '재기목형 창립',
      description: '서울 을지로 방산시장에서 목형 제작 사업 시작',
      icon: 'ri-flag-line'
    },
    {
      year: '2000년대',
      title: '사업 확장',
      description: '전국 거래처 확대 및 특수목형 제작 기술 개발',
      icon: 'ri-rocket-line'
    },
    {
      year: '2010년대',
      title: '기술 혁신',
      description: '레이저 가공 기술 도입 및 뉴테크 브랜드 런칭',
      icon: 'ri-lightbulb-line'
    },
    {
      year: '2019년',
      title: '법인 전환',
      description: '주식회사 재기목형으로 법인 전환',
      icon: 'ri-building-line'
    },
    {
      year: '2020년대',
      title: '디지털 전환',
      description: '최신 레이저 장비 도입 및 온라인 견적 시스템 구축',
      icon: 'ri-computer-line'
    },
    {
      year: '현재',
      title: '업계 선도',
      description: '30년 전통과 최신 기술의 조화로 업계 최고 수준 유지',
      icon: 'ri-trophy-line'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">회사 연혁</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600">30년 전통의 발자취</p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-amber-500 via-slate-700 to-amber-500 hidden lg:block"></div>

          <div className="space-y-12">
            {historyData.map((item, index) => (
              <div
                key={index}
                className={`flex items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow border border-amber-100">
                    <div className="text-2xl font-bold text-amber-600 mb-2">{item.year}</div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>

                <div className="hidden lg:flex items-center justify-center w-16 h-16 flex-shrink-0 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full shadow-lg z-10">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>

                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
